import React from 'react';
import { Box, ButtonBase, Paper, Typography } from '@mui/material';
import { alpha } from '@mui/material/styles';

const answerAccent = ['primary', 'secondary', 'success', 'warning'];

const normalizeOption = (suggestion) => {
  if (typeof suggestion === 'string') {
    return { label: suggestion, value: suggestion };
  }

  return {
    label: String(suggestion?.label ?? suggestion?.value ?? '').trim(),
    value: String(suggestion?.value ?? suggestion?.label ?? '').trim(),
  };
};

const QuickAnswers = ({
  suggestions = [],
  disabled = false,
  onSelect,
  compact = false,
  selectedValue = '',
  columns = { xs: '1fr', sm: 'repeat(2, minmax(0, 1fr))' },
}) => {
  const options = suggestions.map(normalizeOption).filter((option) => option.label && option.value);

  if (!options.length) return null;

  return (
    <Box sx={{ mt: { xs: compact ? 0.75 : 1.5, md: 2.5 } }}>
      <Typography variant="caption" sx={{ display: compact ? 'none' : 'block', mb: 1, fontWeight: 900, color: 'text.secondary' }}>
        اختر إجابة سريعة
      </Typography>
      <Box sx={{ display: 'grid', gridTemplateColumns: columns, gap: { xs: 0.75, sm: 1 } }}>
        {options.map((option, index) => {
          const color = answerAccent[index % answerAccent.length];
          const selected = selectedValue && String(selectedValue) === String(option.value);

          return (
            <ButtonBase
              key={`${option.value}-${index}`}
              disabled={disabled}
              onClick={() => onSelect(option.value, option.label)}
              aria-label={`اختيار ${option.label}`}
              sx={{ width: '100%', borderRadius: 2, textAlign: 'right', minHeight: compact ? 42 : 52 }}
            >
              <Paper
                variant="outlined"
                sx={(theme) => ({
                  width: '100%',
                  p: { xs: compact ? 0.85 : 1.15, sm: 1.5 },
                  borderRadius: 2,
                  borderColor: selected ? theme.palette[color].main : alpha(theme.palette[color].main, 0.28),
                  background: selected
                    ? `linear-gradient(135deg, ${alpha(theme.palette[color].main, 0.20)}, ${alpha(theme.palette.background.paper, 0.98)})`
                    : `linear-gradient(135deg, ${alpha(theme.palette[color].main, 0.08)}, ${alpha(theme.palette.background.paper, 0.96)})`,
                  transition: 'transform 160ms ease, box-shadow 160ms ease, border-color 160ms ease',
                  opacity: disabled ? 0.58 : 1,
                  boxShadow: selected ? `0 12px 28px ${alpha(theme.palette[color].main, 0.16)}` : 'none',
                  '&:hover': disabled
                    ? {}
                    : {
                        transform: 'translateY(-2px)',
                        borderColor: theme.palette[color].main,
                        boxShadow: `0 14px 28px ${alpha(theme.palette[color].main, 0.16)}`,
                      },
                })}
              >
                <Typography sx={{ fontWeight: 900, color: 'text.primary', lineHeight: compact ? 1.45 : 1.7, fontSize: { xs: compact ? '0.84rem' : '0.94rem', sm: '1rem' } }}>
                  {option.label}
                </Typography>
              </Paper>
            </ButtonBase>
          );
        })}
      </Box>
    </Box>
  );
};

export default QuickAnswers;
